/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "antd";
import { TableRecordProps } from "../../ducks/types";

interface PropsType {
  proposal: any;
  setTableRecord: React.Dispatch<React.SetStateAction<TableRecordProps | null>>;
  sentFollowUp: () => void;
  // handleCardStatusChange: (
  //   status: string,
  //   proposalId: string,
  //   hasDocument?: boolean | undefined
  // ) => void;
}

export default function Sent(props: PropsType) {
  const { proposal, sentFollowUp, setTableRecord } = props;
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #FFF1A699", backgroundColor: "#FFF9D999" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/sent.svg" alt="" />
        <Button
          htmlType="button"
          className="yellow-btn btn-sm"
          type="primary"
          onClick={() => {
            sentFollowUp();
            setTableRecord(proposal);
          }}
          style={{ backgroundColor: "#E6C300" }}
        >
          Follow-up
        </Button>
      </div>
      <h5>
        Status:{" "}
        <span style={{ color: "#E6C300", fontWeight: "700" }}>Sent</span>
      </h5>
      <h6
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        {" "}
        Waiting on the customer’s acceptance.{" "}
      </h6>
    </div>
  );
}
